import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Primary, Secondary } from "@cinch-labs/design-system";
import styles from "./auth-buttons.module.css";
import { useAnalytics } from "@cinch-nx/shared-analytics";
import { useRouter } from "next/router";
import { handleButtonClick } from "./auth-buttons.helper";
export const AuthButtons = ({ useBrowserNavigation  })=>{
    const { trackEvent  } = useAnalytics();
    const { push  } = useRouter();
    return /*#__PURE__*/ _jsxs("section", {
        className: styles.authButtonsContainer,
        children: [
            /*#__PURE__*/ _jsx(Primary, {
                classNames: {
                    button: styles.authButton
                },
                type: "button",
                onClick: ()=>{
                    handleButtonClick("sign-up", trackEvent, useBrowserNavigation, push);
                },
                isFullWidth: true,
                children: "Sign up"
            }),
            /*#__PURE__*/ _jsx(Secondary, {
                classNames: {
                    button: styles.authButton
                },
                type: "button",
                onClick: ()=>handleButtonClick("login", trackEvent, useBrowserNavigation, push),
                isFullWidth: true,
                children: "Log in"
            })
        ]
    });
};
